import './style.css'

// ===== CONFIG =====
const API_BASE = (import.meta as any).env?.VITE_API_URL || 'http://localhost:8788'
let token = ''
function setToken(t: string) { token = t }
function clearToken() { token = ''; sessionStorage.removeItem('sp_token') }

async function refreshAccessToken(): Promise<string | null> {
  const rt = sessionStorage.getItem('sp_refresh')
  if (!rt) return null
  try {
    const res = await fetch(`${API_BASE}/api/v1/auth/refresh`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ refreshToken: rt }) })
    const data = await res.json()
    if (res.ok && data.success) {
      token = data.token
      sessionStorage.setItem('sp_token', data.token)
      sessionStorage.setItem('sp_refresh', data.refreshToken)
      return data.token
    }
  } catch {}
  return null
}

async function req(method: string, path: string, body?: any) {
  const url = `${API_BASE}${path}`
  const headers: Record<string,string> = { 'Content-Type':'application/json' }
  if (token) headers['Authorization'] = `Bearer ${token}`
  const opts: RequestInit = { method, headers }
  if (body) opts.body = JSON.stringify(body)
  try {
    const res = await fetch(url, opts)
    if (res.status === 401 && path !== '/api/v1/auth/refresh' && path !== '/api/v1/auth/login') {
      const newToken = await refreshAccessToken()
      if (newToken) {
        headers['Authorization'] = `Bearer ${newToken}`
        const retry = await fetch(url, opts)
        const data = await retry.json()
        return { ok: retry.ok, status: retry.status, data }
      }
    }
    const data = await res.json()
    return { ok: res.ok, status: res.status, data }
  } catch (e: any) {
    return { ok: false, status: 0, data: null, error: 'Network error: ' + (e?.message || '') }
  }
}
const api = {
  login: (e:string,p:string)=> req('POST','/api/v1/auth/login',{email:e,password:p}),
  register: (payload:any)=> req('POST','/api/v1/auth/register',payload),
  me: ()=> req('POST','/api/v1/auth/me'),
  refresh: (refreshToken:string)=> req('POST','/api/v1/auth/refresh',{refreshToken}),
  getUsers: ()=> req('GET','/api/v1/users'),
  createUser: (p:any)=> req('POST','/api/v1/users',p),
  updateUser: (id:string,p:any)=> req('PUT',`/api/v1/users/${id}`,p),
  toggleUser: (id:string)=> req('PATCH',`/api/v1/users/${id}/toggle`),
  deleteUser: (id:string)=> req('DELETE',`/api/v1/users/${id}`),
  getAlerts: (qs='')=> req('GET',`/api/v1/alerts${qs}`),
  createAlert: (p:any)=> req('POST','/api/v1/alerts',p),
  resolveAlert: (id:string)=> req('POST',`/api/v1/alerts/${id}/resolve`),
  getDevices: ()=> req('GET','/api/v1/devices'),
  getContacts: ()=> req('GET','/api/v1/contacts'),
  createContact: (p:any)=> req('POST','/api/v1/contacts',p),
  updateContact: (id:string,p:any)=> req('PUT',`/api/v1/contacts/${id}`,p),
  toggleContact: (id:string)=> req('PATCH',`/api/v1/contacts/${id}/toggle`),
  deleteContact: (id:string)=> req('DELETE',`/api/v1/contacts/${id}`),
  createDevice: (p:any)=> req('POST','/api/v1/devices',p),
  deleteDevice: (id:string)=> req('DELETE',`/api/v1/devices/${id}`),
  patchDevice: (id:string,p:any)=> req('PATCH',`/api/v1/devices/${id}/status`,p),
  getNotifications: ()=> req('GET','/api/v1/notifications'),
  updateNotifications: (p:any)=> req('PUT','/api/v1/notifications',p),
  getAnalytics: ()=> req('GET','/api/v1/analytics/dashboard'),
  getMapData: ()=> req('GET','/api/v1/map/data'),
  getPlans: ()=> req('GET','/api/v1/plans'),
  createPlan: (p:any)=> req('POST','/api/v1/plans',p),
  updatePlan: (id:string,p:any)=> req('PUT',`/api/v1/plans/${id}`,p),
  deletePlan: (id:string)=> req('DELETE',`/api/v1/plans/${id}`),
  getAlertNotifications: (id:string)=> req('GET',`/api/v1/alerts/${id}/notifications`),
  exportAlerts: (qs:string)=> { const u=`${API_BASE}/api/v1/alerts/export/csv${qs}`; window.open(u,'_blank') },
  testEvo: (p:any)=> req('POST','/api/v1/notifications/test-evolution',p),
  deleteAccount: ()=> req('DELETE','/api/v1/auth/me'),
  logoutAll: ()=> req('POST','/api/v1/auth/logout-all'),
  get2faSetup: ()=> req('GET','/api/v1/2fa/setup'),
  verify2fa: (code:string)=> req('POST','/api/v1/2fa/verify',{code}),
  disable2fa: (code:string)=> req('POST','/api/v1/2fa/disable',{code}),
  get2faBackupCodes: ()=> req('GET','/api/v1/2fa/backup-codes'),
  get2faStatus: ()=> req('GET','/api/v1/2fa/status'),
  check2faLogin: (code:string)=> req('POST','/api/v1/2fa/login-check',{code}),
  getGroups: ()=> req('GET','/api/v1/groups'),
  getGroup: (id:string)=> req('GET',`/api/v1/groups/${id}`),
  createGroup: (p:any)=> req('POST','/api/v1/groups',p),
  updateGroup: (id:string,p:any)=> req('PUT',`/api/v1/groups/${id}`,p),
  deleteGroup: (id:string)=> req('DELETE',`/api/v1/groups/${id}`),
  addGroupMember: (id:string,uid:string)=> req('POST',`/api/v1/groups/${id}/members`,{user_id:uid}),
  removeGroupMember: (id:string,uid:string)=> req('DELETE',`/api/v1/groups/${id}/members/${uid}`),
    getRetentionPolicy: ()=> req('GET','/api/v1/retention/policy'),
  updateRetentionPolicy: (p:any)=> req('PUT','/api/v1/retention/policy',p),
  purgeData: ()=> req('POST','/api/v1/retention/purge'),
  getComplianceReport: ()=> req('GET','/api/v1/retention/compliance'),
}

// ===== LOCAL FALLBACK DB =====
const DBK='securepulse_v2'
function db(){try{return JSON.parse(localStorage.getItem(DBK)!)}catch(e){return null}}
function dbSave(d:any){localStorage.setItem(DBK,JSON.stringify(d))}
function initDB(){
  if(localStorage.getItem(DBK))return
  dbSave({users:[],alerts:[],devices:[],ncfg:{whatsapp:true,waNums:'',call:true,callNum:'',sound:true,vibration:true,cooldown:30,evoUrl:'',evoKey:''}})
}

// ===== WEBSOCKET LIVE DATA =====
let wsConn: WebSocket | null = null
let wsReconnectTimer: ReturnType<typeof setTimeout> | null = null
const WS_RECONNECT_MS = 5000

function connectAlertHub(groupId: string) {
  if (!groupId || !API_BASE) return
  // Cerrar conexion anterior
  if (wsConn) { try { wsConn.close() } catch {} wsConn = null }
  if (wsReconnectTimer) { clearTimeout(wsReconnectTimer); wsReconnectTimer = null }

  const wsUrl = API_BASE.replace(/^http/, 'ws') + `/ws/alerts?groupId=${encodeURIComponent(groupId)}`
  console.log('[WS] connecting to', wsUrl)
  const ws = new WebSocket(wsUrl)
  wsConn = ws

  ws.onopen = () => {
    console.log('[WS] connected to AlertHub')
    toast('Conectado a live data','ok')
  }
  ws.onmessage = (ev) => {
    try {
      const msg = JSON.parse(ev.data)
      console.log('[WS] message:', msg)
      if (msg.type === 'new_alert') {
        handleLiveAlert(msg.alert)
      }
    } catch (e) {
      console.error('[WS] parse error:', e)
    }
  }
  ws.onclose = () => {
    console.log('[WS] closed, reconnecting in', WS_RECONNECT_MS, 'ms')
    wsConn = null
    wsReconnectTimer = setTimeout(() => connectAlertHub(groupId), WS_RECONNECT_MS)
  }
  ws.onerror = (err) => {
    console.error('[WS] error:', err)
  }
}

function disconnectAlertHub() {
  if (wsConn) { try { wsConn.close() } catch {} wsConn = null }
  if (wsReconnectTimer) { clearTimeout(wsReconnectTimer); wsReconnectTimer = null }
}

function handleLiveAlert(alert: any) {
  // Actualizar badge de alertas
  const navBdg = document.getElementById('navBdg')
  if (navBdg) {
    const current = parseInt(navBdg.textContent || '0')
    navBdg.textContent = String(current + 1)
    navBdg.style.display = 'inline-block'
  }
  // Toast inmediato
  const typeNames: Record<string,string> = { security: 'Seguridad', medical: 'Alerta Medica', fire: 'Bomberos' }
  toast(`🚨 Nueva alerta ${typeNames[alert.type] || alert.type} — ${alert.user_name}`, 'er')
  // Refrescar dashboard/alerts si estamos en esas vistas
  if (CP === 'dashboard') renderDash()
  if (CP === 'alerts') renderAlerts()
  if (CP === 'map') renderMap()
}

// ===== STATE =====
let CU: any = null // current user
let CP = 'dashboard'
let MAP_FILTER = 'all'
let mapInst: any = null
let mapMarkers: any[] = []
let AT: any = null, ASec = 0, AId: string|null = null
let ULoc = {lat:10.4912,lng:-66.8798,accuracy:0}
let API_MODE = true

// ===== TOAST =====
function toast(msg: string, type='in'){
  const icons: Record<string,string>={ok:'fa-check-circle',er:'fa-circle-xmark',wa:'fa-triangle-exclamation',in:'fa-circle-info'}
  const tc=document.getElementById('TC')!
  const t=document.createElement('div')
  t.className='toast '+type
  t.innerHTML=`<i class="fas ${icons[type]||icons.in}"></i><span class="tm">${esc(msg)}</span>`
  tc.appendChild(t)
  setTimeout(()=>{t.classList.add('rm');setTimeout(()=>t.remove(),300)},3500)
}
function esc(s:string){const e=document.createElement('div');e.textContent=s;return e.innerHTML}

// ===== NAVIGATION =====
function showScr(s: string){
  document.getElementById('scrLogin')!.style.display=s==='login'?'flex':'none'
  document.getElementById('scrReg')!.style.display=s==='reg'?'flex':'none'
}
function nav(page: string){
  CP=page
  document.getElementById('SIDEBAR')!.classList.remove('open')
  document.getElementById('sbOv')!.classList.remove('show')
  document.querySelectorAll('.ni').forEach((n)=>{n.classList.toggle('act',(n as HTMLElement).dataset.p===page)})
  document.querySelectorAll('.page').forEach((p)=>{p.classList.toggle('act',p.id==='pg-'+page)})
  const titles: Record<string,string>={dashboard:'Dashboard',map:'Mapa en Tiempo Real',alerts:'Historial de Alertas',users:'Gestion de Usuarios',groups:'Gestion de Grupos',notifications:'Configuracion de Notificaciones',subscription:'Planes de Suscripcion',iot:'Modulo IoT',profile:'Mi Perfil',settings:'2FA y Privacidad'}
  document.getElementById('pgTitle')!.textContent=titles[page]||'Dashboard'
  switch(page){
    case 'dashboard':renderDash();break
    case 'map':renderMap();break
    case 'alerts':renderAlerts();break
    case 'users':renderUsers();break
    case 'groups':renderGroups();break
    case 'notifications':renderNotif();renderContacts();break
    case 'subscription':renderPlans();break
    case 'iot':renderIoT();break
    case 'profile':renderProfile();break
    case 'settings':renderSettings();break
  }
}

function buildNav(){
  const r=CU.role
  let h=''
  h+=`<div class="ns"><div class="ns-t">Principal</div>`
  h+=`<div class="ni act" data-p="dashboard"><i class="fas fa-gauge-high"></i> Dashboard</div>`
  h+=`<div class="ni" data-p="alerts"><i class="fas fa-bell"></i> Alertas <span class="nb" id="navBdg" style="display:none">0</span></div>`
    if(r==='admin'||r==='superadmin') h+=`<div class="ni" data-p="map"><i class="fas fa-map"></i> Mapa</div>`
  h+=`</div>`
  if(r==='admin'||r==='superadmin'){
    h+=`<div class="ns"><div class="ns-t">Gestion</div>`
    h+=`<div class="ni" data-p="users"><i class="fas fa-users"></i> Usuarios</div>`
    h+=`<div class="ni" data-p="groups"><i class="fas fa-people-group"></i> Grupos</div>`
    h+=`<div class="ni" data-p="notifications"><i class="fas fa-paper-plane"></i> Notificaciones</div>`
    h+=`</div>`
  }
  if(r==='superadmin'){
    h+=`<div class="ns"><div class="ns-t">Plataforma</div>`
    h+=`<div class="ni" data-p="iot"><i class="fas fa-microchip"></i> Modulo IoT</div>`
    h+=`<div class="ni" data-p="subscription"><i class="fas fa-credit-card"></i> Planes</div>`
    h+=`</div>`
  }
  if(r==='user'){
    h+=`<div class="ns"><div class="ns-t">Mi Cuenta</div>`
    h+=`<div class="ni" data-p="notifications"><i class="fas fa-paper-plane"></i> Mis Notificaciones</div>`
    h+=`<div class="ni" data-p="subscription"><i class="fas fa-credit-card"></i> Mi Plan</div>`
    h+=`</div>`
  }
  h+=`<div class="ns"><div class="ni" data-p="profile"><i class="fas fa-user-gear"></i> Mi Perfil</div>`
    h+=`<div class="ni" data-p="settings"><i class="fas fa-shield-halved"></i> 2FA y Privacidad</div></div>`
  document.getElementById('SBNAV')!.innerHTML=h
  document.getElementById('SBNAV')!.onclick=(e)=>{
    const ni=(e.target as HTMLElement).closest('.ni') as HTMLElement|null
    if(ni&&ni.dataset.p) nav(ni.dataset.p)
  }
}
function updateSbUser(){
  document.getElementById('sbAv')!.textContent=(CU.name[0]+CU.lastname[0]).toUpperCase()
  document.getElementById('sbNm')!.textContent=CU.name+' '+CU.lastname
  document.getElementById('sbRl')!.textContent=CU.role==='superadmin'?'Super Administrador':CU.role==='admin'?'Administrador':'Usuario'
}
function toggleSb(){
  document.getElementById('SIDEBAR')!.classList.toggle('open')
  document.getElementById('sbOv')!.classList.toggle('show')
}

function enterApp(){
  document.getElementById('scrLogin')!.style.display='none'
  document.getElementById('scrReg')!.style.display='none'
  document.getElementById('APP')!.style.display='block'
  buildNav();updateSbUser();nav('dashboard');getGeo()
  toast('Bienvenido, '+CU.name,'ok')
  // Conectar WebSocket live data por grupo
  if (CU?.group_id || CU?.group) {
    connectAlertHub(CU.group_id || CU.group)
  }
}
function logout(){
  disconnectAlertHub()
  CU=null;clearToken();document.getElementById('APP')!.style.display='none';showScr('login')
}

function gid(){return 'id_'+Date.now().toString(36)+Math.random().toString(36).slice(2,7)}
function fmtDate(iso:string){
  const d=new Date(iso)
  return d.toLocaleDateString('es')+' '+d.toLocaleTimeString('es',{hour:'2-digit',minute:'2-digit'})
}
const typeLbl: Record<string,string>={security:'Seguridad',medical:'Alerta Medica',fire:'Bomberos'}
const typeIco: Record<string,string>={security:'fa-shield-halved',medical:'fa-heart-pulse',fire:'fa-fire-extinguisher'}

function statusLabel(st:string){ return st==='active'?'Activa':st==='resolved'?'Resuelta':st==='cancelled'?'Cancelada':st }
function alertHtml(a: any, userName=''){
  const acc = a.accuracy ? ` ±${Math.round(a.accuracy)}m` : ''
  const loc = (a.lat!=null && a.lng!=null) ? `${a.lat.toFixed(4)}, ${a.lng.toFixed(4)}${acc}` : 'Sin ubicacion'
  const notifBtn = a.id ? `<button class="btn btn-g btn-sm" data-al-not="${a.id}" style="margin-top:6px"><i class="fas fa-paper-plane"></i> Notificaciones</button>` : ''
  return `<div class="ai"><div class="ai-i ${a.type}"><i class="fas ${typeIco[a.type]}"></i></div><div class="ai-b"><div class="ai-t">${typeLbl[a.type]}</div><div class="ai-d">${esc(userName||'')} — ${loc}<br>${esc(a.address||'')}</div>${notifBtn}</div><div class="ai-m"><div class="ai-time">${fmtDate(a.created_at||a.at)}</div><span class="st ${a.status}">${statusLabel(a.status)}</span></div></div>`
}

// ===== GEO =====
function getGeo(){
  if(!navigator.geolocation){document.getElementById('geoC')!.textContent='Geolocalizacion no soportada';return}
  navigator.geolocation.getCurrentPosition((pos)=>{
    ULoc={lat:pos.coords.latitude,lng:pos.coords.longitude,accuracy:pos.coords.accuracy}
    document.getElementById('geoC')!.textContent=`${ULoc.lat.toFixed(6)}, ${ULoc.lng.toFixed(6)} | ${Math.round(ULoc.accuracy)}m`
  },()=>{
    document.getElementById('geoC')!.textContent=`${ULoc.lat.toFixed(6)}, ${ULoc.lng.toFixed(6)} | Simuladas`
  },{enableHighAccuracy:true,timeout:10000})
}

// ===== MAP =====
async function renderMap(){
  const container = document.getElementById('mapContainer')!
  if(!mapInst){
    mapInst = (window as any).L.map(container).setView([ULoc.lat, ULoc.lng], 14)
    ;(window as any).L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors', maxZoom: 19 }).addTo(mapInst)
  }
  if(!API_MODE){ container.innerHTML = '<div class="empty"><i class="fas fa-map"></i><p>Mapa no disponible sin conexion</p></div>'; return }
  const r = await api.getMapData()
  if(!r.ok || !r.data.success){ toast('Error cargando mapa','er'); return }
  mapMarkers.forEach((m:any)=> mapInst.removeLayer(m))
  mapMarkers = []
  const typeColors: Record<string,string> = {security:'#ef4444', medical:'#f59e0b', fire:'#f97316'}
  const typeLbl: Record<string,string> = {security:'Seguridad', medical:'Medica', fire:'Bomberos'}
  const alerts = r.data.alerts.filter((a:any)=> MAP_FILTER==='all' || a.type===MAP_FILTER)
  let bounds: any[] = []
  for(const a of alerts){
    if(a.lat==null || a.lng==null) continue
    const col = typeColors[a.type] || '#ef4444'
    // Heatmap circles: mas solidos y con halo para destacar contra el fondo del mapa
    const circle = (window as any).L.circleMarker([a.lat,a.lng], {radius: 16, color: col, fillColor: col, fillOpacity: 0.75, weight: 3, opacity: 1}).addTo(mapInst)
    const popup = `<strong>${typeLbl[a.type] || a.type}</strong><br>${esc(a.name||'')} ${esc(a.lastname||'')}<br>${esc(a.address||'Sin direccion')}<br>${fmtDate(a.created_at)}<br>Precision: ${a.accuracy ? a.accuracy+'m' : 'N/A'}`
    circle.bindPopup(popup)
    mapMarkers.push(circle)
    bounds.push([a.lat,a.lng])
  }
  const devColors: Record<string,string> = {sirena:'#ef4444', portero:'#06b6d4', puerta:'#10b981', camara:'#a855f7', sensor:'#f59e0b'}
  for(const d of (r.data.devices || [])){
    const lat = d.lat ?? ULoc.lat
    const lng = d.lng ?? ULoc.lng
    const icon = (window as any).L.divIcon({className:'', html:`<div style="background:${devColors[d.type]||'#64748b'};width:12px;height:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 8px rgba(0,0,0,.4)" title="${d.name}"></div>`})
    const m = (window as any).L.marker([lat,lng], {icon}).addTo(mapInst)
    m.bindPopup(`<strong>${esc(d.name)}</strong><br>${esc(d.type)}<br>${esc(d.status)}<br>${esc(d.loc||'')}`)
    mapMarkers.push(m)
    bounds.push([lat,lng])
  }
  if(bounds.length) mapInst.fitBounds(bounds, {padding:[20,20], maxZoom:16})
  const statusEl = document.getElementById('mapStatus'); if (statusEl) statusEl.textContent = `${alerts.length} alertas activas · ${r.data.devices.length} dispositivos`
}

const mapFilEl = document.getElementById('mapFil');
if (mapFilEl) mapFilEl.addEventListener('click', (e:any)=>{
  const btn = e.target.closest('[data-mf]')
  if(!btn) return
  document.querySelectorAll('#mapFil .tfb').forEach((b:any)=>b.classList.remove('act'))
  btn.classList.add('act')
  MAP_FILTER = btn.dataset.mf
  renderMap()
})

// ===== DASHBOARD =====
async function renderDash(){
  if(API_MODE){
    const {ok,data}=await api.getAnalytics()
    if(ok&&data.success){
      const s=data.stats
      document.getElementById('statsG')!.innerHTML=`
        <div class="sc"><div class="si2" style="background:rgba(239,68,68,.15);color:var(--red)"><i class="fas fa-triangle-exclamation"></i></div><div class="sv" style="color:var(--red)">${s.active}</div><div class="sl">Alertas Activas</div></div>
        <div class="sc"><div class="si2" style="background:rgba(245,158,11,.15);color:var(--amber)"><i class="fas fa-chart-line"></i></div><div class="sv" style="color:var(--amber)">${s.month}</div><div class="sl">Este Mes</div></div>
        <div class="sc"><div class="si2" style="background:rgba(16,185,129,.15);color:var(--green)"><i class="fas fa-check-circle"></i></div><div class="sv" style="color:var(--green)">${s.resolved}</div><div class="sl">Resueltas</div></div>
        <div class="sc"><div class="si2" style="background:rgba(6,182,212,.15);color:var(--cyan)"><i class="fas fa-users"></i></div><div class="sv" style="color:var(--cyan)">${s.users}</div><div class="sl">${CU.role==='user'?'Contactos':'Usuarios'}</div></div>`
      updBdg(s.active)
    } else {
      document.getElementById('statsG')!.innerHTML=`<div class="sc"><div class="si2" style="background:rgba(239,68,68,.15);color:var(--red)"><i class="fas fa-triangle-exclamation"></i></div><div class="sv" style="color:var(--red)">0</div><div class="sl">Alertas Activas</div></div>
        <div class="sc"><div class="si2" style="background:rgba(245,158,11,.15);color:var(--amber)"><i class="fas fa-chart-line"></i></div><div class="sv" style="color:var(--amber)">0</div><div class="sl">Este Mes</div></div>
        <div class="sc"><div class="si2" style="background:rgba(16,185,129,.15);color:var(--green)"><i class="fas fa-check-circle"></i></div><div class="sv" style="color:var(--green)">0</div><div class="sl">Resueltas</div></div>
        <div class="sc"><div class="si2" style="background:rgba(6,182,212,.15);color:var(--cyan)"><i class="fas fa-users"></i></div><div class="sv" style="color:var(--cyan)">0</div><div class="sl">${CU.role==='user'?'Contactos':'Usuarios'}</div></div>`
    }
    // Recent alerts via API
    const r=await api.getAlerts('?limit=5')
    if(r.ok&&r.data.success&&r.data.alerts.length){
      document.getElementById('recentAl')!.innerHTML=r.data.alerts.map((a:any)=>alertHtml(a,(a.name && a.lastname ? a.name + ' ' + a.lastname : '')||'')).join('')
    } else {
      document.getElementById('recentAl')!.innerHTML=localRecentFallback()
    }
  } else {
    // Local fallback render same as proto
    const d=db();if(!d)return
    const ids=visIds(d)
    const ua=d.alerts.filter((a:any)=>ids.includes(a.userId))
    const act=ua.filter((a:any)=>a.status==='active')
    const now=new Date()
    const mo=ua.filter((a:any)=>{const dd=new Date(a.at);return dd.getMonth()===now.getMonth()&&dd.getFullYear()===now.getFullYear()})
    const tu=d.users.filter((u:any)=>ids.includes(u.id)).length
    document.getElementById('statsG')!.innerHTML=`<div class="sc"><div class="si2" style="background:rgba(239,68,68,.15);color:var(--red)"><i class="fas fa-triangle-exclamation"></i></div><div class="sv" style="color:var(--red)">${act.length}</div><div class="sl">Alertas Activas</div></div>
      <div class="sc"><div class="si2" style="background:rgba(245,158,11,.15);color:var(--amber)"><i class="fas fa-chart-line"></i></div><div class="sv" style="color:var(--amber)">${mo.length}</div><div class="sl">Este Mes</div></div>
      <div class="sc"><div class="si2" style="background:rgba(16,185,129,.15);color:var(--green)"><i class="fas fa-check-circle"></i></div><div class="sv" style="color:var(--green)">${ua.filter((a:any)=>a.status==='resolved').length}</div><div class="sl">Resueltas</div></div>
      <div class="sc"><div class="si2" style="background:rgba(6,182,212,.15);color:var(--cyan)"><i class="fas fa-users"></i></div><div class="sv" style="color:var(--cyan)">${tu}</div><div class="sl">${CU.role==='user'?'Contactos':'Usuarios'}</div></div>`
    const recent=ua.slice().sort((a:any,b:any)=>new Date(b.at).getTime()-new Date(a.at).getTime()).slice(0,5)
    document.getElementById('recentAl')!.innerHTML=recent.length?recent.map((a:any)=>alertHtml(a)).join(''):emptyState('Sin alertas','fa-bell-slash')
    updBdg(act.length)
  }
}
function localRecentFallback(){ return emptyState('Sin alertas recientes','fa-bell-slash') }
function visIds(d:any){
  if(CU.role==='superadmin') return d.users.map((u:any)=>u.id)
  if(CU.role==='admin') return d.users.filter((u:any)=>u.group===CU.group||u.id===CU.id).map((u:any)=>u.id)
  return [CU.id]
}
function updBdg(count:number){
  const b1=document.getElementById('topBadge')!
  const b2=document.getElementById('navBdg')!
  if(count>0){ b1.style.display='inline'; b1.textContent=String(count); b2.style.display='inline'; b2.textContent=String(count); }
  else { b1.style.display='none'; b2.style.display='none'; }
}
function emptyState(text:string,icon:string){return `<div class="empty"><i class="fas ${icon}"></i><p>${text}</p></div>`}

// ===== ALERTS PAGE =====
async function renderAlerts(){
  const list = document.getElementById('allAl')!
  if(API_MODE){
    const qs = buildAlertQs()
    const r=await api.getAlerts(`?limit=100${qs}`)
    if(r.ok&&r.data.success&&r.data.alerts.length){
      list.innerHTML=r.data.alerts.map((a:any)=>alertHtml(a,(a.name && a.lastname ? a.name + ' ' + a.lastname : '')||'')).join('')
    } else {
      list.innerHTML=emptyState('No hay alertas','fa-bell-slash')
    }
  } else {
    const d=db(); if(!d) return
    const ids=visIds(d)
    const al=d.alerts.filter((a:any)=>ids.includes(a.userId))
    al.sort((a:any,b:any)=>new Date(b.at).getTime()-new Date(a.at).getTime())
    list.innerHTML=al.length?al.map((a:any)=>alertHtml(a)).join(''):emptyState('No hay alertas','fa-bell-slash')
  }
}

function buildAlertQs(){
  let q=''
  const activeBtn = document.querySelector('#alertFil .tfb.act') as HTMLElement|null
  const f = activeBtn?.dataset.f
  if(f && f!=='all'){
    if(f==='active') q+='&status=active'
    else q+=`&type=${f}`
  }
  const fromV=(document.getElementById('afFrom') as HTMLInputElement|null)?.value
  const toV=(document.getElementById('afTo') as HTMLInputElement|null)?.value
  if(fromV) q+=`&from=${fromV}`
  if(toV) q+=`&to=${toV}`
  return q
}
(document.getElementById('alertFil') as HTMLElement|null)?.addEventListener('click',(e)=>{
  const btn=(e.target as HTMLElement).closest('.tfb') as HTMLElement|null
  if(!btn)return
  document.querySelectorAll('#alertFil .tfb').forEach((b)=>b.classList.remove('act'))
  btn.classList.add('act')
  const f=btn.dataset.f
  if(API_MODE){
    api.getAlerts(`?limit=100${f&&f!=='all'?'type='+f:f==='active'?'&status=active':''}`).then((r:any)=>{
      if(r.ok&&r.data.success) document.getElementById('allAl')!.innerHTML=r.data.alerts.length?r.data.alerts.map((a:any)=>alertHtml(a,(a.name && a.lastname ? a.name + ' ' + a.lastname : '')||'')).join(''):emptyState('No hay alertas','fa-bell-slash')
    })
  }
})

// ===== PANIC =====
document.getElementById('btnPanic')!.onclick=()=>document.getElementById('panicExp')!.classList.add('show')
document.getElementById('peClose')!.onclick=()=>document.getElementById('panicExp')!.classList.remove('show')
document.querySelectorAll('.po').forEach((el)=>{
  const node=el as HTMLElement
  node.onclick=()=>triggerAlert(node.dataset.type!)
  node.onkeydown=(e:KeyboardEvent)=>{if(e.key==='Enter') triggerAlert(node.dataset.type!)}
})

async function triggerAlert(type:string){
  document.getElementById('panicExp')!.classList.remove('show')
  const cfg:any={security:{ico:'fa-shield-halved',txt:'Alerta de Seguridad',col:'var(--red)',bg:'linear-gradient(135deg,#ef4444,#991b1b)'},medical:{ico:'fa-heart-pulse',txt:'Alerta Medica',col:'var(--amber)',bg:'linear-gradient(135deg,#f59e0b,#92400e)'},fire:{ico:'fa-fire-extinguisher',txt:'Alerta de Bomberos',col:'#f97316',bg:'linear-gradient(135deg,#f97316,#9a3412)'}}[type]
  const ov=document.getElementById('alertOv')!
  const iconEl=document.getElementById('aaIcon') as HTMLElement
  iconEl.style.background=cfg.bg
  iconEl.innerHTML=`<i class="fas ${cfg.ico}"></i>`
  document.getElementById('aaText')!.textContent=cfg.txt+' Activa'
  ;(document.getElementById('aaText') as HTMLElement).style.color=cfg.col
  document.getElementById('aaSub')!.textContent='Enviando notificaciones via WhatsApp y llamada automatica...'
  ov.classList.add('show')

  ASec=0;AId=null
  if(AT){clearInterval(AT);AT=null}
  AT=window.setInterval(()=>{
    ASec++
    document.getElementById('aaTimer')!.textContent=String(Math.floor(ASec/60)).padStart(2,'0')+':'+String(ASec%60).padStart(2,'0')
  },1000)

  if(API_MODE){
    const r=await api.createAlert({type,lat:ULoc.lat,lng:ULoc.lng,accuracy:ULoc.accuracy})
    if(r.ok&&r.data.success){
      AId=r.data.alert.id
      toast('Alerta activada y enviada','ok')
    } else {
      toast('Error al activar alerta','er')
      console.error(r)
    }
  } else {
    const d=db()!
    const alert={id:gid(),userId:CU.id,type,status:'active',lat:ULoc.lat,lng:ULoc.lng,at:new Date().toISOString(),rt:null}
    d.alerts.push(alert);dbSave(d);AId=alert.id
  }
}

document.getElementById('aaCancel')!.onclick=cancelAlert

async function showAlertNotifications(alertId: string) {
  const r = await api.getAlertNotifications(alertId)
  if(!r.ok || !r.data?.success){ toast('Error cargando notificaciones','er'); return }
  const list = (r.data.notifications || []) as any[]
  if(!list.length){ toast('Sin notificaciones registradas','in'); return }
  const html = list.map(n => `<tr><td>${esc(n.channel||'')}</td><td>${esc(n.recipient||'')}</td><td>${esc(n.status||'')}</td><td>${esc(n.sent_at||'')}</td></tr>`).join('')
  document.getElementById('legalTitle')!.textContent = 'Notificaciones de alerta'
  document.getElementById('legalBody')!.innerHTML = `<table style='width:100%;font-size:13px'><thead><tr><th>Canal</th><th>Destinatario</th><th>Estado</th><th>Enviado</th></tr></thead><tbody>${html}</tbody></table>`
  document.getElementById('modLegal')!.classList.add('show')
}
document.addEventListener('click', (e: Event) => {
  const t = e.target as HTMLElement
  const btn = t.closest('[data-al-not]') as HTMLElement | null
  if(btn && btn.dataset.alNot){ showAlertNotifications(btn.dataset.alNot) }
})
async function cancelAlert(){
  if(AT){clearInterval(AT);AT=null}
  document.getElementById('alertOv')!.classList.remove('show')
  if(AId){
    if(API_MODE) await api.resolveAlert(AId)
    else { const d=db()!; const a=d.alerts.find((x:any)=>x.id===AId); if(a){a.status='resolved';a.rt=new Date().toISOString();dbSave(d);} }
    AId=null
  }
  toast('Alerta cancelada y registrada','ok')
  if(CP==='dashboard') renderDash(); else if(CP==='alerts') renderAlerts()
}

// ===== USERS =====
let _usersCache: any[] = []
async function loadUsersCache(){
  if(!API_MODE) return []
  const r = await api.getUsers()
  if(r.ok && r.data?.success){ _usersCache = r.data.users || [] }
  return _usersCache
}

async function renderUsers(){
  if(API_MODE){
    const r=await api.getUsers()
    if(r.ok&&r.data.success){
      const users = r.data.users
      _usersCache = users
      const colors=['#ef4444','#f59e0b','#10b981','#06b6d4','#a855f7','#ec4899','#f97316']
      let h=''
      users.forEach((u:any,i:number)=>{
        const c=colors[i%colors.length]
        const ini=(u.name[0]+u.lastname[0]).toUpperCase()
        h+=`<tr><td><div class="uc"><div class="ua" style="background:${c}">${ini}</div><div><div class="un">${esc(u.name+' '+u.lastname)}</div><div class="ue">${esc(u.email)}</div></div></div></td>`
        h+=`<td><span class="rb ${u.role}">${u.role}</span></td>`
        h+=`<td><span class="pb2 ${u.plan}">${u.plan}</span></td>`
        h+=`<td style="font-size:12px;color:var(--fg3)">${esc(u.group_name||'—')}</td>`
        h+=`<td><span class="st ${u.active?'resolved':'active'}">${u.active?'Activo':'Inactivo'}</span></td>`
        h+=`<td><div class="ac">`
        h+=`<button class="ab ed" data-edit="${u.id}" title="Editar"><i class="fas fa-pen"></i></button>`
        if(u.id!==CU.id) h+=`<button class="ab" data-toggle="${u.id}" title="${u.active?'Desactivar':'Activar'}"><i class="fas fa-${u.active?'ban':'check'}"></i></button>`
        if(u.id!==CU.id&&CU.role==='superadmin') h+=`<button class="ab" data-del="${u.id}" title="Eliminar"><i class="fas fa-trash"></i></button>`
        h+=`</div></td></tr>`
      })
      document.getElementById('uTbody')!.innerHTML=h||emptyTr()
    }
  } else {
    const d=db();if(!d)return
    const users=CU.role==='superadmin'?d.users:d.users.filter((u:any)=>u.group===CU.group||u.id===CU.id)
    const colors=['#ef4444','#f59e0b','#10b981','#06b6d4','#a855f7','#ec4899','#f97316']
    let h=''
    users.forEach((u:any,i:number)=>{
      const c=colors[i%colors.length]
      const ini=(u.name[0]+u.lastname[0]).toUpperCase()
      h+=`<tr><td><div class="uc"><div class="ua" style="background:${c}">${ini}</div><div><div class="un">${esc(u.name+' '+u.lastname)}</div><div class="ue">${esc(u.email)}</div></div></div></td>`
      h+=`<td><span class="rb ${u.role}">${u.role}</span></td>`
      h+=`<td><span class="pb2 ${u.plan}">${u.plan}</span></td>`
      h+=`<td style="font-size:12px;color:var(--fg3)">${esc(u.group||'—')}</td>`
      h+=`<td><span class="st ${u.active?'resolved':'active'}">${u.active?'Activo':'Inactivo'}</span></td>`
      h+=`<td><div class="ac">`
      h+=`<button class="ab ed" data-edit="${u.id}" title="Editar"><i class="fas fa-pen"></i></button>`
      if(u.id!==CU.id) h+=`<button class="ab" data-toggle="${u.id}" title="${u.active?'Desactivar':'Activar'}"><i class="fas fa-${u.active?'ban':'check'}"></i></button>`
      if(u.id!==CU.id&&CU.role==='superadmin') h+=`<button class="ab" data-del="${u.id}" title="Eliminar"><i class="fas fa-trash"></i></button>`
      h+=`</div></td></tr>`
    })
    document.getElementById('uTbody')!.innerHTML=h||emptyTr()
  }
}
function emptyTr(){return `<tr><td colspan="6"><div class="empty"><i class="fas fa-users-slash"></i><p>Sin usuarios</p></div></td></tr>`}

document.getElementById('uTbody')!.onclick=(e)=>{
  const btn=(e.target as HTMLElement).closest('.ab') as HTMLElement|null
  if(!btn)return
  if(btn.dataset.edit) openUserMod(btn.dataset.edit)
  else if(btn.dataset.toggle) toggleUserSt(btn.dataset.toggle)
  else if(btn.dataset.del) delUser(btn.dataset.del)
}

document.getElementById('btnNewUser')!.onclick=()=>openUserMod()

async function openUserMod(uid?:string){
  const d=API_MODE ? null : db(); if(!API_MODE && !d) return
  ;(document.getElementById('frmUser') as HTMLFormElement).reset()
  ;(document.getElementById('ufId') as HTMLInputElement).value=''
  document.getElementById('muTitle')!.textContent='Nuevo Usuario'
  document.getElementById('ufPh')!.textContent=''

  const rs=document.getElementById('ufR') as HTMLSelectElement
  rs.innerHTML=CU.role==='admin'?'<option value="user">Usuario</option>':'<option value="user">Usuario</option><option value="admin">Admin</option><option value="superadmin">SuperAdmin</option>'

  const gSel = document.getElementById('ufG') as HTMLSelectElement
  if(API_MODE){
    await loadGroupsCache()
    fillGroupSelect(gSel, true)
  } else {
    gSel.innerHTML = '<option value="">Sin grupo</option>'
    if(uid && d){
      const u2 = d.users.find((x:any)=>x.id===uid)
      if(u2 && u2.group){
        const o2 = document.createElement('option'); o2.value = u2.group; o2.textContent = u2.group; gSel.appendChild(o2)
      }
    }
  }

  if(uid){
    let u: any = null
    if(API_MODE){
      // Asegurar cache fresca
      if(!_usersCache.length) await loadUsersCache()
      u = _usersCache.find((x:any)=>x.id===uid)
    } else if(d){
      u = d.users.find((x:any)=>x.id===uid)
    }
    if(!u){ toast('Usuario no encontrado','er'); return }
    document.getElementById('muTitle')!.textContent='Editar Usuario'
    ;(document.getElementById('ufId') as HTMLInputElement).value=u.id
    ;(document.getElementById('ufN') as HTMLInputElement).value=u.name || ''
    ;(document.getElementById('ufL') as HTMLInputElement).value=u.lastname || ''
    ;(document.getElementById('ufE') as HTMLInputElement).value=u.email || ''
    ;(document.getElementById('ufP') as HTMLInputElement).value=u.phone || ''
    ;(document.getElementById('ufR') as HTMLSelectElement).value=u.role || 'user'
    ;(document.getElementById('ufPn') as HTMLSelectElement).value=u.plan || 'free'
    gSel.value = API_MODE ? (u.group_id || '') : (u.group || '')
    document.getElementById('ufPh')!.textContent='(vacio = sin cambios)'
  }
  document.getElementById('modUser')!.classList.add('show')
}

document.getElementById('frmUser')!.onsubmit=async (e)=>{
  e.preventDefault()
  const id=(document.getElementById('ufId') as HTMLInputElement).value
  const email=(document.getElementById('ufE') as HTMLInputElement).value.trim().toLowerCase()
  const pass=(document.getElementById('ufPs') as HTMLInputElement).value
  const groupSel = (document.getElementById('ufG') as HTMLSelectElement)
  const payload:any = {
    name:(document.getElementById('ufN') as HTMLInputElement).value.trim(),
    lastname:(document.getElementById('ufL') as HTMLInputElement).value.trim(),
    email,
    phone:(document.getElementById('ufP') as HTMLInputElement).value.trim(),
    role:(document.getElementById('ufR') as HTMLSelectElement).value,
    plan:(document.getElementById('ufPn') as HTMLSelectElement).value,
  }
  if(API_MODE){
    const gid = groupSel.value
    if(gid){
      payload.group_id = gid
      const g = _groupsCache.find((x:any) => x.id === gid)
      if(g) payload.group = g.name
    } else {
      payload.group = ''
    }
  } else {
    payload.group = groupSel.value.trim()
  }
  if (pass) payload.password = pass
  if(API_MODE){
    const r = id ? await api.updateUser(id, payload) : await api.createUser(payload)
    if(!r.ok || !r.data?.success){ toast(r.data?.error || 'Error al guardar usuario', 'er'); return }
    toast(id?'Usuario actualizado':'Usuario creado','ok')
  } else {
    const d=db()!
    if(d.users.some((u:any)=>u.email===email&&u.id!==id)){toast('Correo ya en uso','er');return}
    if(id){
      const u=d.users.find((x:any)=>x.id===id)!
      u.name=payload.name;u.lastname=payload.lastname;u.email=email;u.phone=payload.phone;
      u.role=payload.role;u.plan=payload.plan;u.group=payload.group
      if(pass) u.password=pass
      dbSave(d); toast('Usuario actualizado','ok')
    } else {
      if(!pass){toast('Contrasena obligatoria','er');return}
      d.users.push({id:gid(),name:payload.name,lastname:payload.lastname,email,phone:payload.phone,password:pass,role:payload.role,plan:payload.plan,group:payload.group,active:true,created:new Date().toISOString().split('T')[0]})
      dbSave(d); toast('Usuario creado','ok')
    }
  }
  document.getElementById('modUser')!.classList.remove('show'); renderUsers()
}

async function toggleUserSt(id:string){
  if(API_MODE){
    const r = await api.toggleUser(id)
    if(!r.ok || !r.data?.success){ toast('Error al cambiar estado','er'); return }
    toast(r.data.active ? 'Usuario activado' : 'Usuario desactivado', 'ok')
  } else {
    const d=db()!; const u=d.users.find((x:any)=>x.id===id)!; u.active=!u.active; dbSave(d)
    toast('Usuario '+(u.active?'activado':'desactivado'),'ok')
  }
  renderUsers()
}
async function delUser(id:string){
  if(!confirm('Eliminar este usuario permanentemente?')) return
  if(API_MODE){
    const r = await api.deleteUser(id)
    if(!r.ok || !r.data?.success){ toast(r.data?.error || 'Error al eliminar','er'); return }
    toast('Usuario eliminado','ok')
  } else {
    const d=db()!; d.users=d.users.filter((u:any)=>u.id!==id); d.alerts=d.alerts.filter((a:any)=>a.userId!==id); dbSave(d); toast('Usuario eliminado','ok')
  }
  renderUsers()
}

// ===== NOTIFICATIONS =====
async function renderNotif(){
  const notifCards = document.getElementById('notifCards')!
  notifCards.innerHTML = '<div class="empty"><i class="fas fa-circle-notch fa-spin"></i><p>Cargando configuracion...</p></div>'

  const res = API_MODE ? await api.getNotifications() : { ok: true, data: { success: true, config: db()?.ncfg || {} } }
  if (!res.ok || !res.data?.success) {
    notifCards.innerHTML = '<div class="empty"><i class="fas fa-triangle-exclamation"></i><p>Error cargando configuracion</p></div>'
    return
  }
  const cfg = res.data.config || {}

  // Map API field names to UI shorthand
  const c: any = {
    wa_enabled: cfg.wa_enabled ?? 1,
    wa_numbers: cfg.wa_numbers ?? '',
    call_enabled: cfg.call_enabled ?? 1,
    call_number: cfg.call_number ?? '',
    sound: cfg.sound ?? 1,
    vibration: cfg.vibration ?? 1,
    cooldown: cfg.cooldown ?? 30,
    evo_url: cfg.evo_url ?? '',
    evo_key: cfg.evo_key ?? '',
    evo_instance: cfg.evo_instance ?? 'securepulse',
    evo_send_path: cfg.evo_send_path ?? '',
  }

  notifCards.innerHTML = `
    <div class="cc"><h3><i class="fab fa-whatsapp"></i> WhatsApp</h3>
    <div class="tr"><div><div class="tr-l">Enviar alertas via WhatsApp</div><div class="tr-d">Notifica a contactos al activar panico</div></div><button class="tgl ${c.wa_enabled ? 'on' : ''}" id="tglWa" aria-label="WhatsApp"></button></div>
    <div class="fg mt4"><label>Numeros destino (separados por coma)</label><input type="text" class="fi" id="nWaNums" value="${esc(c.wa_numbers)}"></div></div>

    <div class="cc"><h3><i class="fas fa-phone"></i> Llamadas</h3>
    <div class="tr"><div><div class="tr-l">Llamada automatica</div><div class="tr-d">Via Evolution API al activar alerta</div></div><button class="tgl ${c.call_enabled ? 'on' : ''}" id="tglCall" aria-label="Llamada"></button></div>
    <div class="fg mt4"><label>Numero de llamada</label><input type="text" class="fi" id="nCallNum" value="${esc(c.call_number)}"></div></div>

    <div class="cc"><h3><i class="fas fa-mobile-screen"></i> Dispositivo</h3>
    <div class="tr"><div><div class="tr-l">Sonido de alerta</div></div><button class="tgl ${c.sound ? 'on' : ''}" id="tglSnd" aria-label="Sonido"></button></div>
    <div class="tr"><div><div class="tr-l">Vibracion</div></div><button class="tgl ${c.vibration ? 'on' : ''}" id="tglVib" aria-label="Vibracion"></button></div>
    <div class="fg mt4"><label>Cooldown entre alertas (seg)</label><input type="number" class="fi" id="nCd" value="${c.cooldown}" min="5" max="300"></div></div>

    <div class="cc"><h3><i class="fas fa-server"></i> Evolution Manager API</h3>
    <div class="fg"><label>URL Instancia</label><input type="url" class="fi" id="nEvoUrl" value="${esc(c.evo_url)}"></div>
    <div class="fg"><label>API Key</label><input type="password" class="fi" id="nEvoKey" value="${esc(c.evo_key)}"></div>
    <div class="fg"><label>Nombre de instancia Evolution</label><input type="text" class="fi" id="nEvoInstance" value="${esc(c.evo_instance)}" placeholder="securepulse"></div>
    <div class="fg"><label>Path personalizado (opcional, soporta {instance})</label><input type="text" class="fi" id="nEvoSendPath" value="${esc(c.evo_send_path)}" placeholder="auto: prueba /message/sendText, /api/message/sendText, etc"></div>
    <button class="btn btn-s btn-sm mt4" id="btnTestEvo"><i class="fas fa-plug"></i> Probar Conexion</button></div>`

  const toggleMap: Record<string, string> = {
    tglWa: 'wa_enabled', tglCall: 'call_enabled',
    tglSnd: 'sound', tglVib: 'vibration'
  }

  const sendUpdate = async (updates: Record<string, any>) => {
    if (!API_MODE) {
      const d2 = db()!
      Object.assign(d2.ncfg, updates)
      dbSave(d2)
      toast('Configuracion guardada (local)', 'ok')
      return
    }
    toast('Guardando...', 'in')
    const r = await api.updateNotifications(updates)
    if (r.ok && r.data?.success) {
      toast('Configuracion guardada', 'ok')
    } else {
      toast('Error al guardar', 'er')
    }
  }

  for (const [id, key] of Object.entries(toggleMap)) {
    const el = document.getElementById(id) as HTMLElement | null
    if (!el) continue
    el.onclick = () => {
      const currentlyOn = el.classList.contains('on')
      el.classList.toggle('on')
      sendUpdate({ [key]: currentlyOn ? 0 : 1 })
    }
  }

  const inputMap: Record<string, string> = {
    nWaNums: 'wa_numbers',
    nCallNum: 'call_number',
    nEvoUrl: 'evo_url',
    nEvoKey: 'evo_key',
    nEvoInstance: 'evo_instance',
    nEvoSendPath: 'evo_send_path',
  }

  for (const [id, key] of Object.entries(inputMap)) {
    const inp = document.getElementById(id) as HTMLInputElement | null
    if (!inp) continue
    inp.addEventListener('change', () => sendUpdate({ [key]: inp.value }))
  }

  const cdInp = document.getElementById('nCd') as HTMLInputElement | null
  if (cdInp) {
    cdInp.addEventListener('change', () => sendUpdate({ cooldown: parseInt(cdInp.value) || 30 }))
  }

  const testBtn = document.getElementById('btnTestEvo')
  if (testBtn) {
    testBtn.onclick = async () => {
      const url = (document.getElementById('nEvoUrl') as HTMLInputElement | null)?.value || ''
      const key = (document.getElementById('nEvoKey') as HTMLInputElement | null)?.value || ''
      if (!url || !key) { toast('Configura URL y API Key', 'er'); return }
      toast('Probando conexion con Evolution (multi-variante)...', 'in')
      const r = await api.testEvo({ evo_url: url, evo_key: key })
      if (r.ok && r.data.success) {
        const usedUrl = r.data.used_url || '(?)'
        const usedHeader = r.data.used_header || '(?)'
        const detected = r.data.detected_instance
        toast(`OK: ${usedHeader} @ ${usedUrl}` + (detected ? ` (instancia: ${detected})` : ''), 'ok')
      } else {
        const attempts = r.data?.attempts || []
        const msg = r.data?.error || 'Error de conexion'
        toast(msg + (attempts.length ? ' (' + attempts.length + ' variantes probadas)' : ''), 'er')
        // Imprimir detalles en consola para debugging
        console.warn('[test-evo]', { error: msg, attempts })
      }
    }
  }
}

// ===== PLANS =====
async function renderPlans(){
  const g=document.getElementById('plansG')!
  const isSuper = CU.role==='superadmin'
  if(!API_MODE){
    renderPlansStatic(g, isSuper)
    return
  }
  const r = await api.getPlans()
  if(!r.ok || !r.data.success){ g.innerHTML=emptyState('Error cargando planes','fa-triangle-exclamation'); return }
  const plans = (r.data.plans || []).map(function(p:any){
    const feats = (p.features || '').split(',').filter(Boolean)
    return {id:p.id, name:p.name, price:String(p.price), per:p.description || 'por mes', feat: p.name.toLowerCase()==='familiar', iot: p.iot_enabled, f: feats.map(function(t:string){ return {t,o:true} })}
  })
  g.innerHTML = plansHtml(plans, CU.plan, isSuper)
}

function renderPlansStatic(g:HTMLElement, editable:boolean){
  const cp=CU.plan
  const plans=[
    {name:'Free',price:'0',per:'Siempre gratuito',feat:false,f:[{t:'Boton de panico basico',o:true},{t:'3 tipos de alerta',o:true},{t:'Historial (ultimas 10)',o:true},{t:'Geolocalizacion',o:true},{t:'1 contacto emergencia',o:true},{t:'Notificacion WhatsApp',o:false},{t:'Llamada automatica',o:false},{t:'Modulo IoT',o:false}]},
    {name:'Familiar',price:'4.99',per:'por mes',feat:true,f:[{t:'Todo lo de Free',o:true},{t:'Historial ilimitado',o:true},{t:'5 contactos emergencia',o:true},{t:'Notificacion WhatsApp',o:true},{t:'Llamada automatica',o:true},{t:'Sonido y vibracion',o:true},{t:'Modulo IoT',o:false},{t:'Multi-grupo',o:false}]},
    {name:'Grupos',price:'14.99',per:'por mes',feat:false,f:[{t:'Todo lo de Familiar',o:true},{t:'Usuarios ilimitados',o:true},{t:'Panel de administracion',o:true},{t:'Modulo IoT completo',o:true},{t:'Sirena SIRNA',o:true},{t:'Porteros vehiculares',o:true},{t:'Apertura de puertas',o:true},{t:'Soporte prioritario',o:true}]}
  ]
  g.innerHTML = plansHtml(plans, cp, editable)
}

function plansHtml(plans:any[], currentPlan:string, editable:boolean){
  let h=''
  plans.forEach(function(p){
    const cur=currentPlan===p.name.toLowerCase()
    const feat = p.feat || false
    h+=`<div class="pc ${feat?'feat':''}">`
    if(editable) h+=`<div style="text-align:right"><button class="ab ed" data-pedit="${p.id}" title="Editar"><i class="fas fa-pen"></i></button><button class="ab" data-pdel="${p.id}" title="Eliminar"><i class="fas fa-trash"></i></button></div>`
    h+=`<div class="pn">${esc(p.name)}</div><div class="pp">$${esc(p.price)}<span>/${p.per==='por mes'?'mes':''}</span></div><div class="pd">${esc(p.per)}</div><ul>`
    ;(p.f||[]).forEach(function(f:any){ h+=`<li class="${f.o?'':'dis'}"><i class="fas fa-${f.o?'check':'xmark'}"></i> ${esc(f.t)}</li>` })
    if(editable){
      h+=`</div><button class="btn btn-s" style="width:100%" disabled>Administrar</button></div>`
    } else {
      const btnHtml = cur ? '<button class="btn btn-s" disabled style="width:100%;opacity:.5">Plan Actual</button>' : (`<button class="btn ${feat?'btn-p':'btn-s'}" style="width:100%" data-plan="${p.name.toLowerCase()}">${p.price==='0'?'Seleccionar':'Suscribirse'}</button>`)
      h += '</ul>' + btnHtml + '</div>'
    }
  })
  if(editable){
    h+=`<div class="pc" style="display:flex;align-items:center;justify-content:center;min-height:200px;cursor:pointer" id="btnNewPlan"><div class="empty" style="padding:0"><i class="fas fa-plus" style="font-size:32px;color:var(--cyan)"></i><p>Nuevo Plan</p></div></div>`
  }
  return h
}

document.getElementById('plansG')!.onclick=async function(e){
  const btn=(e.target as HTMLElement).closest('[data-plan]') as HTMLElement|null
  if(btn){
    if(!API_MODE){ const d=db()!; const u=d.users.find(function(x:any){ return x.id===CU.id })!; u.plan=btn.dataset.plan!; dbSave(d); CU.plan=btn.dataset.plan!; toast('Plan cambiado','ok'); renderPlans() }
    else toast('Cambio de plan requiere pasarela de pagos','wa')
    return
  }
  const editBtn=(e.target as HTMLElement).closest('[data-pedit]') as HTMLElement|null
  const delBtn=(e.target as HTMLElement).closest('[data-pdel]') as HTMLElement|null
  const newBtn=(e.target as HTMLElement).closest('#btnNewPlan') as HTMLElement|null
  if(newBtn || editBtn){ openPlanMod(editBtn?.dataset.pedit) }
  if(delBtn){
    const id=delBtn.dataset.pdel!
    if(!confirm('Eliminar plan? Los usuarios suscritos seguiran activos pero no se mostrara publicamente.')) return
    const r=await api.deletePlan(id)
    if(r.ok && r.data.success){ toast('Plan eliminado','ok'); renderPlans() }
    else toast('Error','er')
  }
}

function openPlanMod(pid?:string){
  const pf = document.getElementById('frmPlan') as HTMLFormElement
  pf.reset()
  ;(document.getElementById('pfId') as HTMLInputElement).value=pid||''
  document.getElementById('mpTitle')!.textContent=pid?'Editar Plan':'Nuevo Plan'
  document.getElementById('modPlan')!.classList.add('show')
}

document.getElementById('frmPlan')!.onsubmit=async function(e){
  e.preventDefault()
  const id=(document.getElementById('pfId') as HTMLInputElement).value
  const payload={
    name:(document.getElementById('pfN') as HTMLInputElement).value.trim(),
    price:parseFloat((document.getElementById('pfP') as HTMLInputElement).value),
    period:(document.getElementById('pfPeriod') as HTMLSelectElement).value,
    description:(document.getElementById('pfD') as HTMLInputElement).value.trim(),
    features:(document.getElementById('pfF') as HTMLInputElement).value.trim(),
    max_users:(document.getElementById('pfMu') as HTMLInputElement).value ? parseInt((document.getElementById('pfMu') as HTMLInputElement).value) : null,
    max_contacts:(document.getElementById('pfMc') as HTMLInputElement).value ? parseInt((document.getElementById('pfMc') as HTMLInputElement).value) : null,
    iot_enabled:(document.getElementById('pfIoT') as HTMLInputElement).checked ? 1 : 0
  }
  const r = id ? await api.updatePlan(id,payload) : await api.createPlan(payload)
  if(r.ok && r.data.success){ toast(id?'Plan actualizado':'Plan creado','ok'); document.getElementById('modPlan')!.classList.remove('show'); renderPlans() }
  else toast(r.data?.error || 'Error','er')
}

// ===== CONTACTS =====
async function renderContacts(){
  const container = document.getElementById('contactsList')!
  container.innerHTML = '<div class="empty"><i class="fas fa-circle-notch fa-spin"></i><p>Cargando contactos...</p></div>'

  const res = API_MODE ? await api.getContacts() : { ok: true, data: { success: true, contacts: (db()?.contacts || []) } }
  if (!res.ok || !res.data?.success) {
    container.innerHTML = '<div class="empty"><i class="fas fa-triangle-exclamation"></i><p>Error cargando contactos</p></div>'
    return
  }
  const contacts = res.data.contacts || []

  if (!contacts.length) {
    container.innerHTML = emptyState('Sin contactos de emergencia', 'fa-address-book')
    return
  }

  let h = ''
  contacts.forEach((ct: any) => {
    h += '<div class="ai"><div class="ai-i security"><i class="fas fa-user-shield"></i></div>'
    h += '<div class="ai-b"><div class="ai-t">' + esc(ct.name) + '</div>'
    h += '<div class="ai-d">' + esc(ct.phone) + (ct.relationship ? ' — ' + esc(ct.relationship) : '') + '</div></div>'
    h += '<div class="ai-m"><span class="st ' + (ct.active ? 'resolved' : 'active') + '">' + (ct.active ? 'Activo' : 'Inactivo') + '</span></div>'
    h += '<div class="ac">'
    h += '<button class="ab ed" data-cedit="' + ct.id + '" title="Editar"><i class="fas fa-pen"></i></button>'
    if (ct.user_id === CU.id || ['admin','superadmin'].includes(CU.role)) {
      h += '<button class="ab" data-ctoggle="' + ct.id + '" title="' + (ct.active ? 'Desactivar' : 'Activar') + '"><i class="fas fa-' + (ct.active ? 'ban' : 'check') + '"></i></button>'
      h += '<button class="ab" data-cdel="' + ct.id + '" title="Eliminar"><i class="fas fa-trash"></i></button>'
    }
    h += '</div></div>'
  })
  container.innerHTML = h

  container.onclick = (e: Event) => {
    const btn = (e.target as HTMLElement).closest('[data-cedit],[data-ctoggle],[data-cdel]') as HTMLElement | null
    if (!btn) return
    if (btn.dataset.cedit) openContactMod(btn.dataset.cedit)
    else if (btn.dataset.ctoggle) toggleContact(btn.dataset.ctoggle)
    else if (btn.dataset.cdel) delContact(btn.dataset.cdel)
  }
}

function openContactMod(cid?: string) {
  const form = document.getElementById('frmContact') as HTMLFormElement
  form.reset()
  ;(document.getElementById('cfId') as HTMLInputElement).value = ''
  document.getElementById('mcTitle')!.textContent = 'Nuevo Contacto'

  if (cid) {
    document.getElementById('mcTitle')!.textContent = 'Editar Contacto'
    ;(document.getElementById('cfId') as HTMLInputElement).value = cid
    // Populate from local cache or refetch (simplified: use localStorage)
    const d = db()!
    const ct = d.contacts?.find((x: any) => x.id === cid)
    if (ct) {
      const n = document.getElementById('cfN') as HTMLInputElement
      const p = document.getElementById('cfP') as HTMLInputElement
      const r = document.getElementById('cfR') as HTMLInputElement
      n.value = ct.name || ''
      p.value = ct.phone || ''
      r.value = ct.relationship || ''
    }
  }
  document.getElementById('modContact')!.classList.add('show')
}

document.getElementById('btnNewContact')!.onclick = () => openContactMod()

document.getElementById('frmContact')!.onsubmit = async (e) => {
  e.preventDefault()
  const id = (document.getElementById('cfId') as HTMLInputElement).value
  const name = (document.getElementById('cfN') as HTMLInputElement).value.trim()
  const phone = (document.getElementById('cfP') as HTMLInputElement).value.trim()
  const relationship = (document.getElementById('cfR') as HTMLInputElement).value.trim()
  if (!name || !phone) { toast('Nombre y telefono son obligatorios', 'er'); return }

  if (API_MODE) {
    const payload = { name, phone, relationship }
    const r = id ? await api.updateContact(id, payload) : await api.createContact(payload)
    if (r.ok && r.data?.success) {
      toast(id ? 'Contacto actualizado' : 'Contacto creado', 'ok')
    } else {
      toast(r.data?.error || 'Error al guardar contacto', 'er'); return
    }
  } else {
    const d = db()!
    if (!d.contacts) d.contacts = []
    if (id) {
      const ct = d.contacts.find((x: any) => x.id === id)
      if (ct) { ct.name = name; ct.phone = phone; ct.relationship = relationship }
    } else {
      d.contacts.push({ id: gid(), user_id: CU.id, name, phone, relationship, active: 1, created_at: new Date().toISOString() })
    }
    dbSave(d)
    toast(id ? 'Contacto actualizado' : 'Contacto creado', 'ok')
  }
  document.getElementById('modContact')!.classList.remove('show')
  renderContacts()
}

async function toggleContact(id: string) {
  if (API_MODE) {
    const r = await api.toggleContact(id)
    if (!r.ok || !r.data?.success) { toast('Error', 'er'); return }
  } else {
    const d = db()!
    const ct = d.contacts?.find((x: any) => x.id === id)
    if (ct) { ct.active = ct.active ? 0 : 1; dbSave(d) }
  }
  toast('Contacto actualizado', 'ok')
  renderContacts()
}

async function delContact(id: string) {
  if (API_MODE) {
    const r = await api.deleteContact(id)
    if (!r.ok || !r.data?.success) { toast('Error', 'er'); return }
  } else {
    const d = db()!
    d.contacts = (d.contacts || []).filter((x: any) => x.id !== id)
    dbSave(d)
  }
  toast('Contacto eliminado', 'ok')
  renderContacts()
}

// ===== IOT =====
async function renderIoT(){
  const g = document.getElementById('iotG')!
  if(CU.role!=='superadmin'){ g.innerHTML=emptyState('Acceso restringido a SuperAdmin','fa-lock'); return }
  if(!API_MODE){ g.innerHTML=emptyState('Modulo IoT requiere conexion','fa-wifi'); return }
  const r = await api.getDevices()
  if(!r.ok || !r.data.success){ g.innerHTML=emptyState('Error cargando dispositivos','fa-triangle-exclamation'); return }
  const devices = r.data.devices || []
  const ico:Record<string,string>={sirena:'fa-bell',portero:'fa-car',puerta:'fa-door-open',camara:'fa-video',sensor:'fa-satellite-dish'}
  const col:Record<string,string>={sirena:'var(--red)',portero:'var(--cyan)',puerta:'var(--green)',camara:'var(--purple)',sensor:'var(--amber)'}
  const lbl:Record<string,string>={sirena:'Activar',portero:'Abrir',puerta:'Abrir'}
  const bcls:Record<string,string>={sirena:'btn-d',portero:'btn-a',puerta:'btn-ok'}
  let h=''
  devices.forEach(function(dev:any){
    const c=col[dev.type]||'var(--fg3)'
    h+=`<div class="id2"><div class="id2-h"><div class="id2-i" style="background:${c}22;color:${c}"><i class="fas ${ico[dev.type]||'fa-microchip'}"></i></div><span class="ds ${dev.status}">${dev.status==='online'?'En linea':'Desconectado'}</span></div>`
    h+=`<div class="id2-n">${esc(dev.name)}</div><div class="id2-l"><i class="fas fa-location-dot"></i> ${esc(dev.loc)}</div>`
    h+=`<div style="font-size:11px;color:var(--fg3);font-family:'JetBrains Mono',monospace;margin-bottom:10px">${esc(dev.topic)}</div>`
    h+=`<div class="id2-a">`
    if(lbl[dev.type]) h+=`<button class="btn ${bcls[dev.type]} btn-sm" data-iot-act="${dev.id}"><i class="fas fa-power-off"></i> ${lbl[dev.type]}</button>`
    else if(dev.type==='camara') h+=`<button class="btn btn-s btn-sm" data-iot-view="${dev.id}"><i class="fas fa-eye"></i> Ver</button>`
    else if(dev.type==='sensor') h+=`<button class="btn btn-s btn-sm" data-iot-read="${dev.id}"><i class="fas fa-wave-square"></i> Leer</button>`
    h+=`<button class="btn btn-s btn-sm" data-iot-del="${dev.id}"><i class="fas fa-trash"></i></button></div></div>`
  })
  g.innerHTML=h||emptyState('Sin dispositivos','fa-microchip')
}

document.getElementById('iotG')!.onclick=async function(e){
  const actBtn=(e.target as HTMLElement).closest('[data-iot-act]') as HTMLElement|null
  if(actBtn){ const id=actBtn.dataset.iotAct!; await api.patchDevice(id,{status:'online'}); toast('Accion ejecutada','ok'); renderIoT(); return }
  const viewBtn=(e.target as HTMLElement).closest('[data-iot-view]') as HTMLElement|null
  if(viewBtn){ toast('Visor camara (simulado)','ok'); return }
  const readBtn=(e.target as HTMLElement).closest('[data-iot-read]') as HTMLElement|null
  if(readBtn){ toast('Sensor sin movimiento','ok'); return }
  const delBtn=(e.target as HTMLElement).closest('[data-iot-del]') as HTMLElement|null
  if(delBtn){ const id=delBtn.dataset.iotDel!; await api.deleteDevice(id); toast('Dispositivo eliminado','ok'); renderIoT(); }
}
document.getElementById('btnNewDev')!.onclick=function(){ (document.getElementById('frmDev') as HTMLFormElement).reset(); document.getElementById('modDev')!.classList.add('show'); }
document.getElementById('frmDev')!.onsubmit=async function(e){
  e.preventDefault()
  const payload={
    name:(document.getElementById('dfN') as HTMLInputElement).value.trim(),
    type:(document.getElementById('dfT') as HTMLSelectElement).value,
    loc:(document.getElementById('dfLoc') as HTMLInputElement).value.trim(),
    topic:(document.getElementById('dfTop') as HTMLInputElement).value.trim()
  }
  if(API_MODE){
    const r=await api.createDevice(payload)
    if(!r.ok || !r.data.success){ toast(r.data?.error || 'Error','er'); return }
  } else {
    const d=db()!; d.devices.push({id:gid(),...payload,status:'online'}); dbSave(d)
  }
  document.getElementById('modDev')!.classList.remove('show'); toast('Dispositivo agregado','ok'); renderIoT()
}


// ===== GROUPS =====
let _groupsCache: any[] = []
async function loadGroupsCache() {
  if(!API_MODE) return []
  const r = await api.getGroups()
  if(r.ok && r.data?.success){ _groupsCache = r.data.groups || [] }
  return _groupsCache
}

function fillGroupSelect(sel: HTMLSelectElement, includeNone = true){
  const current = sel.value
  sel.innerHTML = includeNone ? '<option value="">Sin grupo</option>' : ''
  _groupsCache.forEach((g: any) => {
    if(g.active === 0 && CU.role !== 'superadmin') return
    const o = document.createElement('option')
    o.value = g.id
    o.textContent = g.name + (g.active === 0 ? ' (inactivo)' : '')
    sel.appendChild(o)
  })
  if (current) sel.value = current
}

async function renderGroups(){
  if(!API_MODE){ document.getElementById('gTbody')!.innerHTML = '<tr><td colspan="6"><div class="empty"><i class="fas fa-people-group"></i><p>Requiere conexion</p></div></td></tr>'; return }
  await loadGroupsCache()
  // Tambien cargar planes si el rol es superadmin (para mostrar nombre)
  let planMap: Record<string,string> = {}
  if(CU.role === 'superadmin'){
    const pr = await api.getPlans()
    if(pr.ok && pr.data?.success){ (pr.data.plans || []).forEach((p:any)=>{ planMap[p.id] = p.name }) }
  }
  // Cargar usuarios para mostrar nombre del admin
  const ur = await api.getUsers()
  const userMap: Record<string,string> = {}
  if(ur.ok && ur.data?.success){ (ur.data.users || []).forEach((u:any)=>{ userMap[u.id] = u.name + ' ' + u.lastname }) }
  const colors=['#ef4444','#f59e0b','#10b981','#06b6d4','#a855f7','#ec4899','#f97316']
  let h = ''
  _groupsCache.forEach((g: any, i: number) => {
    const c = colors[i%colors.length]
    const ini = g.name.split(' ').slice(0,2).map((w:string)=>w[0]||'').join('').toUpperCase()
    h += `<tr><td><div class="uc"><div class="ua" style="background:${c}">${ini}</div><div><div class="un">${esc(g.name)}</div><div class="ue">${esc(g.description||'')}</div></div></div></td>`
    h += `<td><span class="pb2">${esc(planMap[g.plan_id] || '—')}</span></td>`
    h += `<td style="font-size:12px">${esc(userMap[g.admin_user_id] || '—')}</td>`
    h += `<td><span class="rb user">${g.member_count||0}</span></td>`
    h += `<td><span class="st ${g.active?'resolved':'active'}">${g.active?'Activo':'Inactivo'}</span></td>`
    h += `<td><div class="ac">`
    h += `<button class="ab ed" data-gedit="${g.id}" title="Editar"><i class="fas fa-pen"></i></button>`
    h += `<button class="ab" data-gmembers="${g.id}" title="Miembros"><i class="fas fa-users"></i></button>`
    if((g.member_count || 0) === 0){ h += `<button class="ab" data-gdel="${g.id}" title="Eliminar"><i class="fas fa-trash"></i></button>` }
    h += `</div></td></tr>`
  })
  document.getElementById('gTbody')!.innerHTML = h || '<tr><td colspan="6"><div class="empty"><i class="fas fa-people-group"></i><p>Sin grupos</p></div></td></tr>'
}

document.getElementById('gTbody')!.onclick = async (e) => {
  const btn = (e.target as HTMLElement).closest('.ab') as HTMLElement|null
  if(!btn) return
  if(btn.dataset.gedit) await openGroupMod(btn.dataset.gedit)
  else if(btn.dataset.gdel) await delGroup(btn.dataset.gdel)
  else if(btn.dataset.gmembers) await openGroupMembers(btn.dataset.gmembers)
}

document.getElementById('btnNewGroup')!.onclick = () => openGroupMod()

async function fillPlanSelect(){
  const sel = document.getElementById('gfPlan') as HTMLSelectElement
  sel.innerHTML = '<option value="">Sin plan</option>'
  const r = await api.getPlans()
  if(r.ok && r.data?.success){
    (r.data.plans || []).forEach((p: any) => {
      const o = document.createElement('option')
      o.value = p.id; o.textContent = p.name
      sel.appendChild(o)
    })
  }
}

async function openGroupMod(gid?: string){
  const f = document.getElementById('frmGroup') as HTMLFormElement
  f.reset()
  ;(document.getElementById('gfId') as HTMLInputElement).value = ''
  document.getElementById('mgTitle')!.textContent = 'Nuevo Grupo'
  await fillPlanSelect()
  if(gid){
    const r = await api.getGroup(gid)
    if(r.ok && r.data?.success){
      const g = r.data.group
      ;(document.getElementById('gfId') as HTMLInputElement).value = g.id
      ;(document.getElementById('gfN') as HTMLInputElement).value = g.name
      ;(document.getElementById('gfD') as HTMLInputElement).value = g.description || ''
      ;(document.getElementById('gfPlan') as HTMLSelectElement).value = g.plan_id || ''
      ;(document.getElementById('gfAct') as HTMLSelectElement).value = String(g.active ?? 1)
      document.getElementById('mgTitle')!.textContent = 'Editar Grupo'
    }
  } else {
    ;(document.getElementById('gfAct') as HTMLSelectElement).value = '1'
  }
  document.getElementById('modGroup')!.classList.add('show')
}

document.getElementById('frmGroup')!.onsubmit = async (e) => {
  e.preventDefault()
  const id = (document.getElementById('gfId') as HTMLInputElement).value
  const payload: any = {
    name: (document.getElementById('gfN') as HTMLInputElement).value.trim(),
    description: (document.getElementById('gfD') as HTMLInputElement).value.trim(),
    plan_id: (document.getElementById('gfPlan') as HTMLSelectElement).value || null,
    active: parseInt((document.getElementById('gfAct') as HTMLSelectElement).value)
  }
  if(!payload.name){ toast('Nombre requerido','er'); return }
  const r = id ? await api.updateGroup(id, payload) : await api.createGroup(payload)
  if(r.ok && r.data?.success){
    toast(id ? 'Grupo actualizado' : 'Grupo creado', 'ok')
    document.getElementById('modGroup')!.classList.remove('show')
    renderGroups()
  } else {
    toast(r.data?.error || 'Error', 'er')
  }
}

async function delGroup(id: string){
  if(!confirm('Eliminar este grupo? Si tiene miembros sera desactivado.')) return
  const r = await api.deleteGroup(id)
  if(r.ok && r.data?.success){
    if(r.data.softDeleted) toast('Grupo desactivado (tiene miembros)','wa')
    else toast('Grupo eliminado','ok')
    renderGroups()
  } else {
    toast(r.data?.error || 'Error', 'er')
  }
}

// Group members management
let _mgmCurrentId: string | null = null
let _mgmCurrentName: string = ''

async function openGroupMembers(gid: string){
  _mgmCurrentId = gid
  const g = _groupsCache.find((x:any)=>x.id===gid)
  _mgmCurrentName = g?.name || ''
  document.getElementById('mgmTitle')!.textContent = 'Miembros: ' + _mgmCurrentName
  ;(document.getElementById('mgmEmail') as HTMLInputElement).value = ''
  document.getElementById('modGroupMembers')!.classList.add('show')
  await renderMgmList()
}

async function renderMgmList(){
  if(!_mgmCurrentId) return
  const r = await api.getGroup(_mgmCurrentId)
  const cont = document.getElementById('mgmList')!
  if(!r.ok || !r.data?.success){ cont.innerHTML = '<div class="empty"><i class="fas fa-triangle-exclamation"></i><p>Error cargando miembros</p></div>'; return }
  const members: any[] = r.data.members || []
  if(!members.length){
    cont.innerHTML = '<div class="empty"><i class="fas fa-user-slash"></i><p>Sin miembros asignados</p></div>'
    return
  }
  const colors=['#ef4444','#f59e0b','#10b981','#06b6d4','#a855f7','#ec4899','#f97316']
  let h = '<table><thead><tr><th>Usuario</th><th>Rol</th><th>Plan</th><th>Estado</th><th></th></tr></thead><tbody>'
  members.forEach((u:any, i:number)=>{
    const c = colors[i%colors.length]
    const ini = (u.name[0] + u.lastname[0]).toUpperCase()
    h += `<tr><td><div class="uc"><div class="ua" style="background:${c}">${ini}</div><div><div class="un">${esc(u.name+' '+u.lastname)}</div><div class="ue">${esc(u.email)}</div></div></div></td>`
    h += `<td><span class="rb ${u.role}">${u.role}</span></td>`
    h += `<td><span class="pb2 ${u.plan}">${u.plan}</span></td>`
    h += `<td><span class="st ${u.active?'resolved':'active'}">${u.active?'Activo':'Inactivo'}</span></td>`
    h += `<td><button class="ab" data-mgm-rm="${u.id}" title="Quitar del grupo"><i class="fas fa-user-minus"></i></button></td></tr>`
  })
  h += '</tbody></table>'
  cont.innerHTML = h
}

document.getElementById('mgmList')!.onclick = async (e) => {
  const btn = (e.target as HTMLElement).closest('[data-mgm-rm]') as HTMLElement|null
  if(!btn || !_mgmCurrentId) return
  const userId = btn.dataset.mgmRm!
  if(!confirm('Quitar este usuario del grupo?')) return
  const r = await api.removeGroupMember(_mgmCurrentId, userId)
  if(r.ok && r.data?.success){ toast('Usuario quitado del grupo','ok'); renderMgmList(); renderGroups() }
  else toast(r.data?.error || 'Error','er')
}

document.getElementById('btnMgmAssign')!.onclick = async () => {
  if(!_mgmCurrentId) return
  const email = (document.getElementById('mgmEmail') as HTMLInputElement).value.trim().toLowerCase()
  if(!email){ toast('Email requerido','er'); return }
  // Buscar usuario por email dentro de la lista cacheada
  const ur = await api.getUsers()
  if(!ur.ok || !ur.data?.success){ toast('Error cargando usuarios','er'); return }
  const u = (ur.data.users || []).find((x:any) => x.email === email)
  if(!u){ toast('Usuario no encontrado','er'); return }
  const r = await api.addGroupMember(_mgmCurrentId, u.id)
  if(r.ok && r.data?.success){
    toast('Usuario asignado','ok')
    ;(document.getElementById('mgmEmail') as HTMLInputElement).value = ''
    renderMgmList(); renderGroups()
  } else {
    toast(r.data?.error || 'Error','er')
  }
}

// ===== PROFILE =====


function renderProfile(){
  document.getElementById('profHead')!.innerHTML=`<div class="pav">${(CU.name[0]+CU.lastname[0]).toUpperCase()}</div>
    <div><h2>${esc(CU.name+' '+CU.lastname)}</h2><p>${esc(CU.email)} — ${esc(CU.phone||'')}</p>
    <div class="pbdg"><span class="rb ${CU.role}">${CU.role}</span><span class="pb2 ${CU.plan}">${CU.plan}</span>${CU.group?`<span class="pb2" style="background:rgba(6,182,212,.15);color:var(--cyan)">${esc(CU.group)}</span>`:''}</div></div>`
  ;(document.getElementById('pName') as HTMLInputElement).value=CU.name
  ;(document.getElementById('pLast') as HTMLInputElement).value=CU.lastname
  ;(document.getElementById('pPhone') as HTMLInputElement).value=CU.phone||''
  ;(document.getElementById('pPass') as HTMLInputElement).value=''
}
document.getElementById('frmProf')!.onsubmit=async (e)=>{
  e.preventDefault()
  const payload: any = {
    name: (document.getElementById('pName') as HTMLInputElement).value.trim(),
    lastname: (document.getElementById('pLast') as HTMLInputElement).value.trim(),
    phone: (document.getElementById('pPhone') as HTMLInputElement).value.trim(),
  }
  const np = (document.getElementById('pPass') as HTMLInputElement).value
  if (np) payload.password = np
  if(API_MODE){
    const r = await api.updateUser(CU.id, payload)
    if(!r.ok || !r.data?.success){ toast(r.data?.error || 'Error al actualizar perfil','er'); return }
    // Refrescar CU desde /me para reflejar cambios
    const me = await api.me()
    if(me.ok && me.data?.user){ CU = { ...CU, ...me.data.user } }
    toast('Perfil actualizado','ok')
    renderProfile(); updateSbUser()
  } else {
    const d=db()!; const u=d.users.find((x:any)=>x.id===CU.id)!
    u.name=payload.name; u.lastname=payload.lastname; u.phone=payload.phone
    if(np) u.password=np
    dbSave(d); CU=u; updateSbUser(); toast('Perfil actualizado','ok'); renderProfile()
  }
}
document.getElementById('btnCloseSes')!.onclick=async ()=>{
  if(!confirm('Cerrar todas las sesiones en otros dispositivos?')) return
  if(API_MODE){
    const r = await api.logoutAll()
    if(r.ok && r.data?.success){ toast('Sesiones cerradas','ok') }
    else toast(r.data?.error || 'Error', 'er')
  } else {
    toast('Sesiones cerradas (simulado)','ok')
  }
}
document.getElementById('btnDelAcc')!.onclick=async function(){
  if(!confirm('Eliminar tu cuenta permanentemente? Se borraran todos tus datos.')) return
  if(API_MODE){
    const r=await api.deleteAccount()
    if(r.ok && r.data.success){ toast('Cuenta eliminada','ok'); logout() }
    else toast(r.data?.error || 'Error', 'er')
  } else { toast('Eliminar cuenta requiere conexion','wa') }
}

// ===== AUTH FORMS =====
document.getElementById('frmLogin')!.onsubmit=async (e)=>{
  e.preventDefault(); const email=(document.getElementById('lEmail') as HTMLInputElement).value.trim().toLowerCase()
  const pass=(document.getElementById('lPass') as HTMLInputElement).value
  if(!email||!pass){toast('Completa todos los campos','er');return}
  if(API_MODE){
    const r=await api.login(email,pass)
    if(r.ok&&r.data&&r.data.success){
      CU=r.data.user; setToken(r.data.token); sessionStorage.setItem('sp_token',r.data.token); sessionStorage.setItem('sp_refresh',r.data.refreshToken); enterApp()
    } else {
      toast(r.data?.error||'Credenciales incorrectas','er')
    }
  } else {
    const d=db()!; const user=d.users.find((u:any)=>u.email===email&&u.password===pass&&u.active)
    if(!user){toast('Credenciales incorrectas','er');return}
    CU=user; sessionStorage.setItem('sp_token','local_'+user.id); enterApp()
  }
}

document.getElementById('frmReg')!.onsubmit=async (e)=>{
  e.preventDefault()
  const email=(document.getElementById('rEmail') as HTMLInputElement).value.trim().toLowerCase()
  const pass=(document.getElementById('rPass') as HTMLInputElement).value
  const name=(document.getElementById('rName') as HTMLInputElement).value.trim()
  if(!email||!pass||!name){toast('Completa los campos obligatorios','er');return}
  if(pass.length<6){toast('Minimo 6 caracteres','er');return}
  if(API_MODE){
    const payload={
      name,lastname:(document.getElementById('rLast') as HTMLInputElement).value.trim(),email,
      phone:(document.getElementById('rPhone') as HTMLInputElement).value.trim(),password:pass,
      plan:(document.getElementById('rPlan') as HTMLSelectElement).value,
      group:(document.getElementById('rGroup') as HTMLInputElement).value.trim(),
      consent:(document.getElementById('rConsent') as HTMLInputElement).checked
    }
    const r=await api.register(payload)
    if(r.ok&&r.data&&r.data.success){
      CU=r.data.user; setToken(r.data.token); sessionStorage.setItem('sp_token',r.data.token); sessionStorage.setItem('sp_refresh',r.data.refreshToken); toast('Cuenta creada','ok'); enterApp()
    } else {
      toast(r.data?.error||'Error al registrar','er')
    }
  } else {
    const d=db()!; if(d.users.some((u:any)=>u.email===email)){toast('Correo ya registrado','er');return}
    const nu={id:gid(),name,lastname:(document.getElementById('rLast') as HTMLInputElement).value.trim(),email,phone:(document.getElementById('rPhone') as HTMLInputElement).value.trim(),password:pass,role:'user',plan:(document.getElementById('rPlan') as HTMLSelectElement).value,group:(document.getElementById('rGroup') as HTMLInputElement).value.trim(),
      consent:(document.getElementById('rConsent') as HTMLInputElement).checked,active:true,created:new Date().toISOString().split('T')[0]}
    d.users.push(nu); dbSave(d); CU=nu; sessionStorage.setItem('sp_token','local_'+nu.id); toast('Cuenta creada','ok'); enterApp()
  }
}

document.getElementById('goRegister')!.onclick=()=>showScr('reg')
document.getElementById('goLogin')!.onclick=()=>showScr('login')
document.getElementById('btnMenu')!.onclick=toggleSb
// Mismo patron mousedown+mouseup para sbOv (consistencia con .mo)
const sbOv = document.getElementById('sbOv')!
let sbDown = false
sbOv.addEventListener('mousedown', (e)=>{ sbDown = (e.target === sbOv) })
sbOv.addEventListener('mouseup', (e)=>{ if(sbDown && e.target === sbOv){ toggleSb() } sbDown = false })
document.getElementById('sbUser')!.onclick=()=>nav('profile')
document.getElementById('btnAlerts')!.onclick=()=>nav('alerts')
document.getElementById('btnLogout')!.onclick=logout

// ===== MODALS =====
document.querySelectorAll('[data-close]').forEach((el)=>{
  (el as HTMLElement).onclick=function(){ const closeId = (el as HTMLElement).dataset.close!; document.getElementById(closeId)!.classList.remove('show') }
})
// Click-outside-to-close: solo cierra si el GESTO completo empezo Y termino sobre el overlay.
// Asi no se cierra si el usuario hace mousedown dentro de un input y suelta fuera (p. ej. arrastrando 
// texto o haciendo click fuera por accidente).
document.querySelectorAll('.mo').forEach((ov)=>{
  let downOnOverlay = false
  ;(ov as HTMLElement).addEventListener('mousedown', (e)=>{
    downOnOverlay = (e.target === ov)
  })
  ;(ov as HTMLElement).addEventListener('mouseup', (e)=>{
    if(downOnOverlay && e.target === ov){ (ov as HTMLElement).classList.remove('show') }
    downOnOverlay = false
  })
})


// ===== LEGAL / PRIVACY =====
const TERMS_HTML = `<h3>Terminos y Condiciones</h3>
<p>Domus-Secura ofrece una plataforma de boton de panico y gestion de alertas. Al registrarte aceptas:</p>
<ul>
  <li>Usar el servicio de forma legal y responsable.</li>
  <li>No generar alertas falsas ni abusar del sistema.</li>
  <li>Mantener tus credenciales de acceso seguras.</li>
  <li>Aceptar que las alertas y ubicaciones se procesan para envio de notificaciones.</li>
</ul>
<p>El servicio se proporciona “tal cual” sin garantias de disponibilidad ininterrumpida.</p>`;

const PRIVACY_HTML = `<h3>Politica de Privacidad</h3>
<p>Domus-Secura respeta tu privacidad de acuerdo a la Ley N. 19.628 de Proteccion de la Vida Privada de Chile.</p>
<ul>
  <li><strong>Datos personales:</strong> nombre, email, telefono, grupo y ubicacion de alertas.</li>
  <li><strong>Finalidad:</strong> gestionar alertas, notificar contactos de emergencia y operar el panel IoT.</li>
  <li><strong>Almacenamiento:</strong> base de datos cifrada en Cloudflare D1.</li>
  <li><strong>Derecho al olvido:</strong> puedes eliminar tu cuenta y todos tus datos desde tu perfil.</li>
  <li><strong>Retencion:</strong> alertas se conservan hasta 12 meses o hasta que elimines tu cuenta.</li>
</ul>`;

function showLegal(title: string, html: string){
  document.getElementById('legalTitle')!.textContent = title
  document.getElementById('legalBody')!.innerHTML = html
  document.getElementById('modLegal')!.classList.add('show')
}

document.getElementById('linkTerms')?.addEventListener('click', function(e){ e.preventDefault(); showLegal('Terminos y Condiciones', TERMS_HTML) })
document.getElementById('linkPrivacy')?.addEventListener('click', function(e){ e.preventDefault(); showLegal('Politica de Privacidad', PRIVACY_HTML) })

// ===== INIT =====
initDB()
const st=sessionStorage.getItem('sp_token')
if(st){
  if(API_MODE){
    setToken(st); api.me().then((r:any)=>{
      if(r.ok&&r.data&&r.data.success){CU=r.data.user;enterApp()}
      else {clearToken();showScr('login')}
    }).catch(()=>{clearToken();showScr('login')})
  } else {
    const d=db()!; const uid=st.replace('local_','')
    const su=d.users.find((u:any)=>u.id===uid&&u.active)
    if(su){CU=su;enterApp()}else{clearToken();showScr('login')}
  }
} else {
  showScr('login')
}

// Escape key closes overlays
document.addEventListener('keydown',(e:KeyboardEvent)=>{
  if(e.key==='Escape'){
    document.getElementById('panicExp')!.classList.remove('show')
    document.querySelectorAll('.mo.show').forEach((m)=>(m as HTMLElement).classList.remove('show'))
  }
})

function renderSettings(){
  const area = document.getElementById('totpSetupArea') as HTMLElement
  const verifyArea = document.getElementById('totpVerifyArea') as HTMLElement
  const backupArea = document.getElementById('totpBackupArea') as HTMLElement

  if(!area) return

  async function loadTOTPStatus(){
    const st = await api.get2faStatus()
    const rp = await api.getRetentionPolicy()

    if(st.ok && st.data?.enabled){
      document.getElementById('totpStatus')!.textContent = '✅ Activo'
      ;(document.getElementById('totpStatus') as HTMLElement).style.color = '#0967dF'
      area.innerHTML = '<p>2FA está habilitado. Usa tu app autenticadora para generar códigos.</p>'
      verifyArea.style.display = 'none'
    } else {
      document.getElementById('totpStatus')!.textContent = 'Inactivo'
      ;(document.getElementById('totpStatus') as HTMLElement).style.color = '#ff6600'
      area.innerHTML = '<button class="btn btn-primary" onclick="setupTOTP()">Habilitar Autenticación de Dos Factores</button>'
      verifyArea.style.display = 'none'
    }

    if(rp.ok && rp.data?.policy){
      const days = rp.data.policy.alertRetentionDays ?? 365
      const pending = rp.data.pendingPurgeCount ?? 0
      document.getElementById('retentionInfo')!.innerHTML =
        '<p>Retención de alertas resueltas/canceladas: <strong>'+days+' días</strong></p>'+
        '<p>Purga automática: <strong>'+(rp.data.policy.autoPurgeEnabled ? 'Activada' : 'Desactivada')+'</strong></p>'+
        (pending ? '<p>Alertas pendientes de purga: <strong>'+pending+'</strong></p>' : '')+
        '<p>Última purga: '+(rp.data.policy.lastPurgeAt || 'Nunca')+'</p>'
    } else {
      document.getElementById('retentionInfo')!.innerHTML = '<p>Configuración de retención no disponible.</p>'
    }
  }

  loadTOTPStatus()

  window.setupTOTP = async function(){
    const r = await api.get2faSetup()
    if(r.ok && r.data?.qrCode){
      area.innerHTML = '<img src="'+r.data.qrCode+'" style="max-width:300px;border-radius:8px;" />' +
        '<p style="font-size:0.9em;color:#888;margin-top:0.5rem">Escanea el QR con tu app de autenticación (Google Authenticator, Authy, etc.)</p>'+
        '<p style="font-size:0.8em;color:#666;word-break:break-all">'+r.data.otpauthUrl+'</p>'
      verifyArea.style.display = 'block'
    } else {
      toast(r.data?.error || 'No se pudo generar QR','er')
    }
  }

  window.verifyTOTP = async function(){
    const code = (document.getElementById('totpCodeInput') as HTMLInputElement).value.trim()
    if(code.length !== 6){ toast('El código debe tener 6 dígitos','er'); return }
    const r = await api.verify2fa(code)
    if(r.ok && r.data?.success){
      toast('2FA habilitado exitosamente','ok')
      document.getElementById('totpSetupArea')!.innerHTML = '<p>✅ Autenticación de dos factores está activa</p>'
      verifyArea.style.display = 'none'

      // Show backup codes
      const bc = await api.get2faBackupCodes()
      if(bc.ok && bc.data?.backupCodes){
        document.getElementById('backupCodesDisplay')!.textContent = bc.data.backupCodes.join(', ')
        backupArea.style.display = 'block'
      }
    } else {
      toast(r.data?.error || 'Código inválido','er')
    }
  }

  window.showPurgeConfirm = async function(){
    if(!confirm('¿Estás seguro? Tu cuenta y TODOS tus datos serán eliminados permanentemente. Esta acción no se puede deshacer.')){ return }
    const r = await api.deleteAccount()
    if(r.ok && r.data?.success){ toast('Cuenta eliminada','ok'); logout() }
    else toast(r.data?.error || 'Error al eliminar cuenta','er')
  }
  window.requestComplianceReport = async function(){
    const r = await api.getComplianceReport()
    if(r.ok && r.data?.compliance){
      const c = r.data.compliance
      const text = 'Datos personales: '+JSON.stringify(c.personalData)+'\n\nRegistros almacenados: '+JSON.stringify(c.storedOn)
      alert(text)
      toast('Reporte de cumplimiento generado','ok')
    } else {
      toast('No se pudo generar el reporte','er')
    }
  }
}

// Prevent double tap zoom
let lt=0;
document.addEventListener('touchend',(e:TouchEvent)=>{const n=Date.now();if(n-lt<=300)e.preventDefault();lt=n},{passive:false})


declare global {
  interface Window {
    setupTOTP: () => Promise<void>
    verifyTOTP: () => Promise<void>
    showPurgeConfirm: () => Promise<void>
    requestComplianceReport: () => Promise<void>
  }
}
